import { Form, useFormikContext } from 'formik';

import { HelmInstallFormValues } from './types';
import { UseGitFormSection } from './UseGitFormSection';
import { GitInstallFormSections } from './GitInstallFormSections';
import { ManualInstallFormSections } from './ManualInstallFormSections';

type Props = {
  namespaces: Array<{ label: string; value: string }>;
  setPreviewIsValid: (isValid: boolean) => void;
};

export function HelmInstallInnerForm({ namespaces, setPreviewIsValid }: Props) {
  const { values, setFieldValue } = useFormikContext<HelmInstallFormValues>();
  return (
    <Form className="form-horizontal">
      <UseGitFormSection
        value={values.useGitOps}
        onChange={(value) => setFieldValue('useGitOps', value)}
      />
      {/* keep GitInstallFormSections and ManualInstallFormSections in the same formik context to keep the similar values in sync, but use different form sections to match each choice */}
      {values.useGitOps ? (
        <GitInstallFormSections
          namespaces={namespaces}
          setPreviewIsValid={setPreviewIsValid}
        />
      ) : (
        <ManualInstallFormSections
          namespaces={namespaces}
          setPreviewIsValid={setPreviewIsValid}
        />
      )}
    </Form>
  );
}
